const VIEWS_RESET = 'VIEWS/RESET';

export default function viewsConfigurationResetAction () {
  return {
    type: VIEWS_RESET,
    payload: {}
  };
}

export { VIEWS_RESET };